class Employeed {
  constructor(empId, name, legajo) {
    this.empId = empId;
    this.name = name;
    this.legajo = legajo;
  }

  static fromJson({ EmpId, Nombre, Legajo }) {
    return new Employeed(EmpId, Nombre, Legajo);
  }
}

export default Employeed;
